import { Component } from '@angular/core';

@Component({
  selector: 'app-pitch',
  templateUrl: './pitch.component.html',
})
export class PitchComponent {

  constructor() {


    window.location.href = "https://docsend.com/view/ridrp69k78r9cwdj";


  }

}
